// To do - To check with yash why we have add below line i.e require('process')
const process = require("process");

export const currentEnv = 'prod';
export const baseUrl = "https://konfhub.com";
export const websiteUrl = "https://events.konfhub.com";
export const loginUrl = "https://accounts.konfhub.com";
export const s3Url = "https://konfhub-image-files-prod.s3.ap-south-1.amazonaws.com"
export const baseUrlQuizhub = "https://quizadmin.konfhub.com";
export const geoLocationAPIKey = "AIzaSyCdKozbbL0QQVyG8PLXmBJ_k6-dpdwkBB0";
export const konfhubTaxID = "29AAVFK1083A1Z8";
export const certhubUrl = "https://cert.konfhub.com";
export const checkinAppUrl = "checkin.konfhub.com";
export const sponsorAppUrl = "sponsor.konfhub.com";
export const mediaUrl = "https://media.konfhub.com";
export const regButtonsUrl = "https://widget.konfhub.com/widget.js";
export const quizHubUrl = "https://quiz.konfhub.com";
export const quizHubAdminUrl = "https://quizadmin.konfhub.com";
export const quizhubAppUrl = "https://join.quizhub.app";
export const stripeClientID = "ca_NLgA6ETGYH5DeYg0AFI7JCWDikQwCO0x";
export const galleryUrl = "https://gallery.konfhub.com";

export const STRIPE_PG = 6;
export const TAP_PG = 7;
export const INDIAN_CURRENCY = "INR"

const currentDate = new Date();
const maintenanceStartDate = new Date(
    process?.env?.MAINTENANCE_START_DATE || "2024-11-03T00:30:00.000+05:30"
);
const maintenanceEndDate = new Date(
    process?.env?.MAINTENANCE_END_DATE || "2024-11-03T02:00:00.000+05:30"
);

export const isMaintenanceTime =
    currentDate > maintenanceStartDate && currentDate < maintenanceEndDate